import {formEncodedApi} from 'nutshell-core/api';

import {openOauthWindow} from '../../../oauth/open-oauth-window';

type Options = {
    authUrl: string;
    authCheckUrl: string;
    windowFeatures: any;
    connectionId?: string | null | undefined;
};

type Result = {
    hasAuth: boolean;
    username?: string;
};

// Returns a promise which resolves to `true` if auth was successfull, and rejects
// with an array of error messages if not.
export function authToService({
    authUrl,
    authCheckUrl,
    windowFeatures,
    connectionId,
}: Options): Promise<Result> {
    return openOauthWindow(
        authUrl,
        'Connect your external service with Nutshell',
        windowFeatures
    ).then(() => {
        const search = connectionId ? {connectionId} : undefined;

        // When the auth window is closed, check the calendar sync status
        return (
            formEncodedApi
                .get(authCheckUrl, search)
                // @ts-expect-error
                .then((res) => res.json())
                .then((data) => {
                    const username = data.username;
                    if (data.hasAuth) {
                        return Promise.resolve({hasAuth: true, username});
                    }
                    if (data.errorMessages && data.errorMessages.length) {
                        return Promise.reject(data.errorMessages);
                    }

                    return Promise.resolve({hasAuth: false, username});
                })
        );
    });
}
